const currentUrl = window.location.href;

const configPara = {
  url: (currentUrl.includes("uat")) ? 'https://contentuat.choose.physio' : 'https://content.choose.physio',
  auth: {
    username: 'api',
    password: 'apaapi'
  }
};

export { configPara };